package utils

import com.example.readingnotes.presentation.admin.AdminPostEditorEvent
import com.example.readingnotes.presentation.admin.AdminPostEditorViewModel

/**
 * Handle image upload from file input
 * @param files File list from input element
 * @param viewModel AdminPostEditorViewModel to handle upload events
 */
fun handleImageUpload(files: dynamic, viewModel: AdminPostEditorViewModel) {
    if (files != null && files.length > 0) {
        val file = files[0]
        println("File selected: ${file.name}, size: ${file.size}, type: ${file.type}")

        // File validation
        val maxSize = 10 * 1024 * 1024 // 10MB
        val allowedTypes = arrayOf("image/png", "image/jpeg", "image/jpg", "image/webp", "image/gif")

        if (file.size > maxSize) {
            viewModel.onEvent(AdminPostEditorEvent.OnImageUploadError("ファイルサイズが大きすぎます（最大10MB）"))
            return
        }

        if (!allowedTypes.contains(file.type)) {
            viewModel.onEvent(AdminPostEditorEvent.OnImageUploadError("対応していないファイル形式です"))
            return
        }

        // Convert file to base64 using browser FileReader
        val reader = js("new FileReader()")
        reader.onload = { event: dynamic ->
            val base64String = event.target.result as String
            val commaIndex = base64String.indexOf(',')
            val base64Data = if (commaIndex != -1) {
                base64String.substring(commaIndex + 1)
            } else {
                base64String
            }

            // Convert base64 to binary
            val binaryString = js("atob(base64Data)")
            val bytes = ByteArray(binaryString.length)
            for (i in 0 until binaryString.length) {
                bytes[i] = binaryString.charCodeAt(i).toByte()
            }

            // Upload image
            viewModel.onEvent(AdminPostEditorEvent.OnUploadImage(file.name, file.type, bytes))

            // Create preview URL
            val objectUrl = js("URL.createObjectURL(file)") as String
            viewModel.onEvent(AdminPostEditorEvent.OnImagePreview(objectUrl))
        }
        reader.onerror = { event: dynamic ->
            println("FileReader error: ${event.target.error}")
            viewModel.onEvent(AdminPostEditorEvent.OnImageUploadError("ファイルの読み込みに失敗しました"))
        }
        reader.readAsDataURL(file)
    }
}
